import { postOrThrow } from '../utils/ApiUtil';
import type { DeliveryAE } from './model';

export const DeliveryLegacyApi = {
  async addOrEditDelivery(deliveryAE: DeliveryAE): Promise<number> {
    const response = await postOrThrow<DeliveryAE, number>('/sparrow/delivery/addOrEdit', deliveryAE);
    return response;
  },
};

/** @deprecated */
export const deliveryApi = DeliveryLegacyApi;
export const deliveryRestApi = DeliveryLegacyApi;
